import React, { useEffect } from "react";
import {
  withSitecoreContext,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { NavigationLinkListProps } from "./types/NavigationLinkList.types";

const NavigationLinkList = (props: NavigationLinkListProps) => {
  const getNavigationList = props?.fields?.Links;
  const [isOpen, setOpen] = React.useState(false);

  const scrollToTop = (element) => {
    const getElement = document?.getElementById(element)?.querySelector(".privacy-collapsible-title") as HTMLElement;
    window?.scrollTo(
      {
        top: (document?.getElementById(element)?.offsetTop ?? 0) - 99,
        behavior: 'smooth'
      }
    );
    if (!getElement?.classList?.contains("open")) {
      getElement?.click();
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const scrollInit = () => {
        let hashTag = window.location.hash as string;
        let getHashId = hashTag && document?.querySelector(`${hashTag}`) as HTMLElement;
        let getAnchorHashItem = (hashTag && (getHashId as HTMLElement)?.querySelector(".privacy-collapsible-title")) as HTMLElement;

        setTimeout(() => {
          window.scrollTo(
            {
              top: (getHashId as HTMLElement)?.offsetTop - 99,
              behavior: 'smooth'
            }
          );
          hashTag && !getAnchorHashItem?.classList?.contains("open") && getAnchorHashItem?.click();
        }, 500);
      }

      scrollInit();

      window.addEventListener('hashchange', () => {
        scrollInit();
      });
    }
  }, [])

  return (

    <>
      {props?.fields && (
        <ul className="privacy-navigation-list">
          {getNavigationList?.map((item) => (
            item?.fields?.SecondaryLinks?.length > 0
              ?
              <li className={`navigation-list-item ${isOpen ? 'open' : ''}`}>
                <div className="navigation-accordion-item" onClick={() => setOpen(!isOpen)}>
                  {item?.fields?.Link?.value?.text}
                </div>
                <ul className="second-links-items">
                  {item?.fields?.SecondaryLinks?.map((secondItems) => (
                    <li className="second-link-item">
                      {secondItems?.fields?.IsInternalAnchor
                        ?
                        <div className="anchor-item"
                          onClick={() => {
                            scrollToTop(secondItems?.fields?.Link?.value?.anchor)
                          }}>
                          {secondItems?.fields?.Link?.value?.text}
                        </div>
                        :
                        <a href={`${secondItems?.fields?.Link?.value?.href}#${secondItems?.fields?.Link?.value?.anchor}`}>
                          {secondItems?.fields?.Link?.value?.text}
                        </a>
                      }
                    </li>
                  ))}
                </ul>
              </li>
              :
              <li className="navigation-list-item">
                {item?.fields?.IsInternalAnchor
                  ?
                  <div className="anchor-item"
                    onClick={() => {
                      scrollToTop(item?.fields?.Link?.value?.anchor)
                    }}>
                    {item?.fields?.Link?.value?.text}
                  </div>
                  :
                  <a href={`${item?.fields?.Link?.value?.href}#${item?.fields?.Link?.value?.anchor}`}>
                    {item?.fields?.Link?.value?.text}
                  </a>
                }
              </li>
          ))}
        </ul>
      )}
    </>

  );
};

export default withSitecoreContext()(NavigationLinkList);
